









































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

import Button from '@/components/atoms/Button.vue';
import Radio from '@/components/atoms/Radio.vue';

@Component({
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: String,
      default: '',
    },
  },
  components: {
    'button-id': Button,
    'radio-id': Radio,
  },
})
export default class EmailPreferenceForm extends Vue {
  @Watch('selected', { immediate: true, deep: true }) // eslint-disable-next-line
  selectedDefault(value: any): void {
    this.radioSelected = value || '';
  }

  radioList = [
    {
      label: 'DAILY',
      value: 'MAX_1_PER_DAY',
    },
    {
      label: 'WEEKLY',
      value: 'MAX_1_PER_WEEK',
    },
    {
      label: 'OFF',
      value: 'UNSUBSCRIBE',
    },
  ];

  radioSelected = '';

  public selectedRadio(event: any): void {
    this.radioSelected = event.target.defaultValue;
  }

  public emailPreferenceClick(): void {
    this.$emit('click', this.radioSelected);
  }
}
